// Die Routen der Haupt-Features. Komponenten lazy, damit Router-Logik ohne `.vue`-Import testbar
// bleibt (der IIFE-Build bettet sie ohnehin in `main.js` ein). Kein `scrollBehavior`: Navigationen
// scrollen nie (Invariante „kein Auto-Scroll", noAutoScroll.spec.ts).

import type {RouteRecordRaw} from 'vue-router';

const KeyboardView = () => import('@/features/keyboard/KeyboardView.vue');

export const routes: RouteRecordRaw[] = [
    {
        path: '/',
        name: 'convert',
        component: () => import('@/features/convert/ConvertView.vue'),
        meta: {mainTab: 'convert'},
    },
    {
        path: '/verlauf',
        name: 'history',
        component: () => import('@/components/file-history/FileHistoryPanel.vue'),
        meta: {mainTab: 'history'},
    },
    {path: '/harmonika', name: 'keyboard', component: KeyboardView, props: {view: 'play'}, meta: {mainTab: 'keyboard'}},
    {
        path: '/harmonika/bass',
        name: 'keyboard-bass',
        component: KeyboardView,
        props: {view: 'bass'},
        meta: {mainTab: 'keyboard'},
    },
    {
        path: '/akkorde',
        name: 'chords',
        component: () => import('@/features/chord-finder/ChordFinderView.vue'),
        meta: {mainTab: 'chords'},
    },
    {
        path: '/einstellungen',
        name: 'settings',
        component: () => import('@/components/settings/SettingsPanel.vue'),
        meta: {mainTab: 'settings', paneClass: 'mx-auto max-w-4xl'},
    },
    // Unbekannter Pfad → Konvertieren; `to.query` ist hier die frisch geparste URL, nicht veraltet.
    {path: '/:pathMatch(.*)*', redirect: (to) => ({name: 'convert', query: to.query})},
];
